import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
    Box, IconButton, Typography,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@material-ui/core'

import Button from 'components/Button/Button'
import IconFactory from 'shared/icons/IconFactory/IconFactory'
import { useStyles } from './DeleteAlertModal_style'

const DeleteAlertModal = (props) => {
    const classes = useStyles()
    const { openDeleteModal, closeModal, handleAlertDelete } = props

    return (
        <Dialog
            open={openDeleteModal}
            onClose={closeModal}
            PaperProps={{ className: classes.dialogContainer }}
            fullWidth
        >
            <DialogTitle disableTypography classes={{ root: classes.dialogTitleRoot }}>
                <Typography variant='h6' className={classes.dialogDeleteAlertTitle}>
                    <FormattedMessage id='delete_offer_popup.alert.title.one'/>
                </Typography>
                <IconButton
                    color='inherit'
                    onClick={closeModal}
                    aria-label='close'
                    className={classes.closeButton}
                >
                    <IconFactory icon='close'/>
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Box className=''>
                        <Typography variant='body2'>
                            <FormattedMessage id='delete_offer_popup.alert.text.one'/>
                        </Typography>
                    </Box>
                </DialogContentText>
                <DialogActions>
                    <Button onClick={closeModal} size='small' variant='secondary'>
                        <FormattedMessage id='delete_offer_popup.option_no' />
                    </Button>
                    <Button onClick={handleAlertDelete} size='small' variant='primary' style={{ marginLeft: 10 }}>
                        <FormattedMessage id='delete_offer_popup.alert.option_yes' />
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteAlertModal
